import React from 'react'

export default function AboutCard() {
    return (
        <>
            <div className='about-card'>
                <div className='about-header'>About</div>
                <img className='about-icon' src='https://image.flaticon.com/icons/svg/912/912316.svg' alt='icon of man' />
                <div className='about-card-info'>
                    <div className='about-text'>
                        Before attending Flatiron School, Taylor Stein completed an MBA at the University of Denver, Daniels College of Business, concentrating 
                        in Business Analytics. He previously received an A.A. Degree in Culinary Arts from the Culinary Institute of America. 
                        After working as a professional cook for himself as a private catering chef and then as the Head Soup Chef for Deer Valley, 
                        Taylor moved on to earn a B.A. in Business from Fordham University, Gabelli School of Business. Taylor’s work experience consists 
                        of corporate training and restaurant management for the restaurant group Barteca. After working as a bar manager, Taylor was promoted to corporate trainer. In this role, 
                        he focused on opening new locations and staff development. After completing his role in the company’s expansion, Taylor was promoted to 
                        assistant general manager. After a rewarding 8-year restaurant career, Taylor left the company and accepted a spot in the DMBA program to 
                        further develop as a leader and deep dive into the world of Big Data. Now, Taylor is seeking full time position in full-stack web development.
                        Keep scrolling to view a timeline of where he's been!
                    </div>
                </div>
            </div>
        </>
    )
}
